import { GetPatientLastAppointmentResponse } from "@/Common/Api/Appointment/Dto/GetPatientLastAppointmentResponse";
import { Client } from "@/Common/Api/Client";
import { UpcomingAppointment } from "@/Common/Models/Appointments/UpcomingAppointment";
import { Server } from "@/Common/Operations/operations.server";

async function getPatientLastAppointment(patientContactId: string): Promise<UpcomingAppointment> {
    const response = await Client.postAsync<GetPatientLastAppointmentResponse>(Server.Myle_GetPatientLastAppointment, {
        PatientContactId: patientContactId
    });

    if (!response.errors.any()) {
        return response.data.LastUpcomingAppointment;
    }

    return null;
}

export { getPatientLastAppointment };
